import { AnyObject } from "@commonlibs";
import StorageRepository from "./StorageRepository";

export default abstract class ObjectStorageRepository<T extends AnyObject> extends StorageRepository<T> {
    protected async getByKey<K extends keyof T>(key: K): Promise<T[K] | undefined> {
        return (await this.get())?.[key];
    }

    protected async update(newValue: Partial<T>): Promise<void> {
        await this.set({ ...(await this.get()), ...newValue } as T);
    }
}
